<template>
    <div class="container-fluid dashboard-2 pt-2">
        <div class="row general-widget">
            <Card1 v-for="(item, index) in widgets as any" :key="index" colClass="col-sm-6 col-xl-3 box-col-6"
                cardClass="card widget-1">
                <div class="widget-content">
                    <div class="widget-round" :class="item.class">
                        <div class="bg-round">
                            <svg class="svg-fill">
                                <use :xlink:href="`/icon-sprite.svg#${item.svg1}`" />
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use :xlink:href="`/icon-sprite.svg#${item.svg2}`" />
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{ item.number }}</h4>
                        <span class="f-light">{{ item.title }}</span>
                    </div>
                </div>
            </Card1>
        </div>
        <div class="card">
            <div class="row card-body">
                <div class="col-md-5 box-col-12">
                    <div class="calendar-default" id="calendar-container">
                        <div id="calendar">
                            <FullCalendar id="calendar" ref="calendarRef" :options="calendarOptions" />
                        </div>
                    </div>
                </div>
                <div class="col-md-7 box-col-12">
                    <Card1 colClass="col-12 box-col-12" cardClass="card" cardhaderClass="card-no-border pb-0"
                        header="true" :title="`Reservation Timeline ${daySelected}`" headerTop="true" haderTitle="true"
                        down="false" cardbodyClass="timeline-card" button="New Reservasi"
                        @button-func="handleNewEvenCalendar">
                        <div class="activity-timeline">
                            <div class="d-flex align-items-start" v-for="(item, index) in listReservation as any"
                                :key="index">
                                <div class="activity-line"></div>
                                <div v-if="item.status == 'RESERVATION'" class="activity-dot-secondary"></div>
                                <div v-else class="activity-dot-primary"></div>
                                <div class="flex-grow-1">
                                    <p class="mt-0 todo-font" v-html="item.reservation_time"></p><span
                                        class="f-w-700">{{ item.name
                                        }}</span>
                                    <p class="mb-0 activity-text">{{ item.keluhan }}</p>
                                </div>
                                <div class="d-flex gap-2">
                                    <div class="btn bg-light-warning border-light-warning text-warning mb-1">
                                        <span @click="handleCardPatiennt(item)">{{ item.sales_name }}</span>
                                    </div>
                                    <div class="d-flex gap-2">
                                        <div class="btn bg-light-success border-light-success text-success"
                                            @click="handleCardPatiennt(item)">{{ item.status }}</div>
                                        <div class="btn bg-light-info border-light-info text-info"
                                            @click="handleEditReservation(item)" title="Edit Reservation">
                                            <i class="fa fa-edit"></i>
                                        </div>
                                        <div v-if="role == 'FINANCE'" class="btn bg-light-danger border-light-danger text-danger"
                                            @click="deleteReservation(item)" title="Delete Reservation">
                                            <i class="fa fa-trash"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card1>
                </div>
            </div>
        </div>
    </div>
    <FormPatient 
        :title="modalState.formPatient.title" 
        :mode="modalState.formPatient.mode"
        :data="modalState.formPatient.data"
        v-if="modalState.formPatient.show"
        @on-closed="closeFormPatient" 
    />
    <ReservationCard 
        :title="modalState.reservationCard.title" 
        :data="modalState.reservationCard.data" 
        v-if="modalState.reservationCard.show"
        @on-closed="closeReservationCard" 
        @on-process="processReservationCard" 
    />
</template>
<script lang="ts" setup>
import { onMounted, ref, defineAsyncComponent, reactive } from "vue"
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
const FormPatient = defineAsyncComponent(() => import("./FormPatient.vue"))
const ReservationCard = defineAsyncComponent(() => import("./ReservationCard.vue"))
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))

// Modal management with prompt system
const modalState = reactive({
  formPatient: {
    show: false,
    title: "",
    mode: "create" as "create" | "update",
    data: null as any
  },
  reservationCard: {
    show: false,
    title: "",
    data: null as any
  }
})

// Legacy refs for backward compatibility
const formtitle = ref("")
const formPatient = ref(false)
const cardtitle = ref("")
const cardPatient = ref(false)
const selectPatient = ref({})

// Modal prompt functions
const promptFormPatient = (options: {
  title?: string,
  mode?: "create" | "update",
  data?: any
} = {}) => {
  modalState.formPatient.show = true
  modalState.formPatient.title = options.title || ""
  modalState.formPatient.mode = options.mode || "create"
  modalState.formPatient.data = options.data || null
  
  // Update legacy refs for compatibility
  formtitle.value = options.title || ""
  formPatient.value = true
}

const promptReservationCard = (options: {
  title?: string,
  data?: any
} = {}) => {
  modalState.reservationCard.show = true
  modalState.reservationCard.title = options.title || ""
  modalState.reservationCard.data = options.data || null
  
  // Update legacy refs for compatibility
  cardtitle.value = options.title || ""
  cardPatient.value = true
  selectPatient.value = options.data || {}
}

const closeFormPatient = () => {
  modalState.formPatient.show = false
  modalState.formPatient.title = ""
  modalState.formPatient.mode = "create"
  modalState.formPatient.data = null
  
  // Update legacy refs for compatibility
  formPatient.value = false
  formtitle.value = ""
  
  refreshCalendar()
  fetchReservations()
}

const closeReservationCard = () => {
  modalState.reservationCard.show = false
  modalState.reservationCard.title = ""
  modalState.reservationCard.data = null
  
  // Update legacy refs for compatibility
  cardPatient.value = false
  cardtitle.value = ""
  selectPatient.value = {}
}

const processReservationCard = () => {
  closeReservationCard()
  refreshCalendar()
  fetchReservations()
}

const widgets = ref([])
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const role = session.getUser().role
const clinics = session.getUser().clinic
// Timeline data
const listReservation = ref([])
import { toast } from 'vue3-toastify'
import * as clinic from "@/api/services/ClinicRequest";
import timeGridPlugin from "@fullcalendar/timegrid";

const calendarRef = ref<any>(null);
const daySelected = ref<string>('');
let lastSelectedInfo: any = null;
let loading = ref<boolean>(false);
const calendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
    initialView: "dayGridMonth",
    editable: false, selectable: true,
    selectMirror: true, dayMaxEvents: true, weekends: true,
    select: handleDateSelect,
    droppable: false,
    headerToolbar: {
        left: "prev,next", center: "title", right: "dayGridMonth",
    },
    events: async function (fetchInfo: any, successCallback: any, failureCallback: any) {
        let list = [] as any
        loading.value = true
        widgets.value = []
        await clinic.postRequest("/reservation/calendar", { start_date: fetchInfo.startStr, end_date: fetchInfo.endStr, clinic: clinics }).then((res) => {
            if (res.status == 200 && res.data) {
                list = res.data.map((item: any) => {
                    return {
                        id: item.ID,
                        title: " (" + item.total + ") " + item.status,
                        start: new Date(item.date).toISOString(),
                        allDay: true
                    }
                })
                widgets.value = Object.values(res.data.reduce((acc: any, item: any) => {
                    if (!acc[item.status]) {
                        acc[item.status] = {
                            class: "success",
                            svg1: "rate",
                            svg2: "halfcircle",
                            number: 0,
                            title: item.status,
                            font: "font-success",
                            icon: "icon-arrow-up",
                            total: "+70%"
                        };
                    }
                    acc[item.status].number += item.total;
                    return acc;
                }, {}));
            }
        })
        loading.value = false
        successCallback(list);
    }
}
async function fetchReservations() {
    listReservation.value = []
    loading.value = true
    await clinic.postRequest("/reservation/list", { page: 1, size: 10000, date: daySelected.value, clinic: session.getUser().clinic }).then((res) => {
        if (res.status == 200 && res.data) {
            listReservation.value = res.data
        }
    })
    loading.value = false
}

async function handleNewEvenCalendar() {
    if (!lastSelectedInfo) {
        alert("Please select a date on the calendar first.");
        return;
    }
    const calendarApi = calendarRef.value?.getApi?.();
    if (!calendarApi) {
        alert("Calendar API not available.");
        return;
    }
    
    // Use new prompt system
    promptFormPatient({
        title: lastSelectedInfo.startStr,
        mode: "create"
    })
}

function handleCardPatiennt(item: any) {
    // Use new prompt system
    promptReservationCard({
        title: `Reservation ${item.name}`,
        data: item
    })
}

// Add new function for editing reservation
function handleEditReservation(item: any) {
    promptFormPatient({
        title: `Edit Reservation - ${item.name}`,
        mode: "update",
        data: item
    })
}

function handleDateSelect(selectInfo: any) {
    daySelected.value = selectInfo.startStr
    lastSelectedInfo = selectInfo;
    formtitle.value = `${selectInfo.startStr}`
    fetchReservations()
}


const deleteReservation = async (item: any) => {
    if (!confirm('Are you sure you want to delete this registration?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await clinic.postRequest("/reservation/delete", { ID: item.ID }).then((resp) => {
            if (resp.status === 200) {
                toast.success('deleted successfully');
                fetchReservations(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete reservation');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete reservation');
    } finally {
        loading.value = false; // End loading state
    }
}
function refreshCalendar() {
    const calendarApi = calendarRef.value?.getApi?.();
    if (calendarApi) {
        calendarApi.refetchEvents();
        // If you use static events and want to rerender, use this:
        // calendarApi.render();
    }
}
onMounted(() => {
    // refreshCalendar()
})
</script>